import React, { Component, createRef } from "react";

//Import CSS

//Import internal components
import AppContext from "../appContext";
import Terms from "./modals/terms";
import Privacy from "./modals/privacy";
import Input from "../components/inputs/input";
import CadastroEmpresa from "./empresa/cadastroEmpresa";
//Import external components
import Alert from "sweetalert2";
import Swal from "sweetalert2";
import MaskedInput from "react-text-mask";
import ReactGA from "react-ga";
import Password from "../components/inputs/password";
import Moment from "moment";
import DateUtils from "../shared/utils/DataUtils";
import CadastroUsuario from "./usuario/cadastroUsuario";
import NumericMenu from "../components/menu/numeric-navigation-menu";
import { createMultiContas } from "../service/multi-contas/multi-contas-service";
import CnpjUtils from "../shared/utils/CnpjUtils";

//Import images

class SignupBody extends Component {
  constructor(props) {
    super(props);

    this.state = {
      redirectL: false,
      opacity: "signup-right",
      loading: false,
      disabled: false,
      terms: false,
      privacy: false,
      newsletter: false,
      nomePF: "",
      option: 1,
      payload: {
        usuario: {},
        empresa: {
          cnpj: CnpjUtils.cleanCnpj(this.props.cnpj),
        },
      },
    };
    this.NumericMenuRef = createRef();
    this.CadastroEmpresaRef = createRef();
    this.CadastroUsuarioRef = createRef();
    SignupBody.contextType = AppContext;
    this.cadastrar = this.cadastrar.bind(this);
    this.webserviceCreate = this.webserviceCreate.bind(this);
    this.ChangeOption = this.ChangeOption.bind(this);
    this.handleClickOk = this.handleClickOk.bind(this);
    this.onClickCloseTerms = this.onClickCloseTerms.bind(this);
    this.onClickClosePrivacy = this.onClickClosePrivacy.bind(this);
  }

  ChangeOption(option) {
    if (option !== this.state.option) {
      if (option === 2 && this.state.option === 1) {
        if (this.CadastroEmpresaRef.current) {
          const isValid = this.CadastroEmpresaRef.current.validateForm();
          if (!isValid) {
            return false;
          }
        }
      }

      this.setState({ option: option }, () => {
        if (this.NumericMenuRef.current) {
          this.NumericMenuRef.current.handleChangeOption(option, false);
        }

        // Focar no primeiro campo da aba ativa
        setTimeout(() => {
          if (option === 1 && this.CadastroEmpresaRef.current && this.CadastroEmpresaRef.current.focusFirstField) {
            this.CadastroEmpresaRef.current.focusFirstField();
          }

          if (option === 2 && this.CadastroUsuarioRef.current && this.CadastroUsuarioRef.current.focusFirstField) {
            this.CadastroUsuarioRef.current.focusFirstField();
          }
        }, 100);
      });
      return true;
    }
    return true;
  }

  handleUpdateUsuario = dadosUsuario => {
    this.setState(prevState => ({
      payload: {
        ...prevState.payload,
        usuario: dadosUsuario,
      },
    }));
  };

  handleUpdateEmpresa = dadosEmpresa => {
    this.setState(prevState => ({
      payload: {
        ...prevState.payload,
        empresa: dadosEmpresa,
      },
    }));
  };

  webserviceCreate() {
    const { onlyS9 } = this.props;
    const { usuario, empresa } = this.state.payload;
    this.context.showLoading("Concluindo cadastro...");

    const payload = {
      nomePF: onlyS9 ? usuario.nome : this.state.nomePF,
      nome: usuario.nome,
      surname: usuario.surname,
      email: usuario.email,
      cpf: usuario.cpf,
      rg: usuario.rg,
      password: usuario.password,
      datanasc: usuario.datanasc ? DateUtils.formatDateOec(usuario.datanasc) : "",
      newsletter: usuario.newsletter,
      onlyS9: onlyS9,
      cnpj: empresa.cnpj,
      dddTelefone: usuario.dddTelefone,
      telefone: usuario.telephone,
      dddCelular: usuario.dddCelular,
      celular: usuario.cellphone,
      papel: usuario.papel,
      referencial: this.props.referencial,
      tipoParticipante: empresa.tipoParticipante,
    };

    // Quando referencial = false, incluir dados da empresa para criar no OEC antes do usuário
    if (!this.props.referencial) {
      payload.razaoSocial = empresa.razaoSocial;
      payload.nomeFantasia = empresa.nomeFantasia;
      payload.cep = empresa.cep;
      payload.logradouro = empresa.logradouro;
      payload.numero = empresa.numero;
      payload.complemento = empresa.complemento;
      payload.bairro = empresa.bairro;
      payload.pontoReferencia = empresa.pontoReferencia;
      payload.estado = empresa.estado;
      payload.cidade = empresa.cidade;
      payload.emailEmpresa = empresa.emailEmpresa;
      payload.dddTelefoneEmpresa = empresa.dddTelefone;
      payload.telefoneEmpresa = empresa.telefone;
      payload.dddCelularEmpresa = empresa.dddCelular;
      payload.celularEmpresa = empresa.celular;
    }

    const requestOptions3 = {
      method: "POST",
      body: JSON.stringify(payload),
    };
    fetch(process.env.REACT_APP_LABS_API + "create_user.php", requestOptions3)
      .then(response => {
        return response.json();
      })
      .then(json => {
        if (json.status === 201 || (json.status === 200 && !this.props.referencial)) {
          const body = {
            idUsuario: json.id,
            email: empresa.emailEmpresa,
            emailUsuario: usuario.email,
            cnpj: empresa.cnpj,
            papel: usuario.papel,
            razaoSocial: empresa.razaoSocial,
            nomeFantasia: empresa.nomeFantasia,
            cep: empresa.cep,
            logradouro: empresa.logradouro,
            numero: empresa.numero,
            complemento: empresa.complemento,
            bairro: empresa.bairro,
            pontoReferencia: empresa.pontoReferencia,
            estado: empresa.estado,
            cidade: empresa.cidade,
            dddTelefone: empresa.dddTelefone,
            telefone: empresa.telefone,
            dddCelular: empresa.dddCelular,
            celular: empresa.celular,
            tipoParticipante: empresa.tipoParticipante,
            referencial: this.props.referencial,
            semMultiConta: true,
          };

          createMultiContas(body).then(response => {
            this.context.hideLoading();
            if (response.status === 201 || response.status === 200) {
              this.finalizaCadastro();
            } else {
              Swal.fire({
                text: response.message,
                icon: "warning",
                title: "Aviso!",
                allowOutsideClick: false,
                showCancelButton: false,
                confirmButtonColor: "#00518b",
                confirmButtonText: "Ok!",
              }).then(result => {
                if (result.value) {
                  this.setState({
                    redirectL: true,
                  });
                }
              });
            }
          });
        } else if (json.status === 201 || (json.status === 200 && this.props.referencial)) {
          this.finalizaCadastro();
        } else if (json.status === 409) {
          document.getElementById("main-body").style.pointerEvents = "";
          this.setState({
            opacity: "signup-right",
            loading: false,
            disabled: false,
          });
          this.context.hideLoading();
          Swal.fire({
            html: json.message,
            icon: "warning",
            title: "Aviso",
            allowOutsideClick: false,
            confirmButtonColor: "#00518b",
            customClass: {
              confirmButton: "x-follow-order__filter-btn",
            },
          }).then(result => {
            if (result.value) {
              this.setState({
                // redirectL: true,
              });
            }
          });
        } else {
          document.getElementById("main-body").style.pointerEvents = "";
          this.setState({
            opacity: "signup-right",
            loading: false,
            disabled: false,
          });
          this.context.hideLoading();
          const errorMessage = json.message || json.errorMessage || "Erro interno. Tente novamente mais tarde.";
          Alert.fire({
            text: errorMessage,
            icon: "error",
            title: "Aviso",
            confirmButtonColor: "#00518b",
            customClass: {
              confirmButton: "x-follow-order__filter-btn",
            },
          });
        }
      });
  }

  finalizaCadastro() {
    document.getElementById("main-body").style.pointerEvents = "";
    this.setState({
      opacity: "signup-right",
      loading: false,
      disabled: false,
    });
    this.context.hideLoading();
    if (!this.props.referencial) {
      Swal.fire({
        html: "Cadastro finalizado. <br> Aguarde a aprovação do time de atendimento Essilor.",
        icon: "success",
        title: "Pronto!",
        allowOutsideClick: false,
        confirmButtonColor: "#00518b",
        confirmButtonText: "Ok!",
      }).then(result => {
        this.handleClickOk();
        if (result.value) {
          this.setState({
            redirectL: true,
          });
        }
      });
    } else {
      Swal.fire({
        html: "Usuário criado com sucesso!<br />Por favor, faça o login para acessar o sistema.",
        icon: "success",
        title: "Pronto!",
        showCancelButton: false,
        allowOutsideClick: false,
        confirmButtonColor: "#00518b",
        confirmButtonText: "Ok!",
      }).then(result => {
        this.handleClickOk();
        if (result.value) {
          this.setState({
            redirectL: true,
          });
        }
      });
    }
  }

  cadastrar(e) {
    if (e && typeof e.preventDefault === "function") {
      e.preventDefault();
    }

    document.getElementById("main-body").style.pointerEvents = "none";
    this.setState({
      opacity: "signup-right signup-main-opacity",
      loading: true,
      disabled: true,
    });
    this.context.showLoading("");

    this.webserviceCreate();
  }

  handleClickOk() {
    ReactGA.event({
      category: "button",
      action: "click",
      label: "ok-final",
    });
  }

  onClickCloseTerms() {
    this.setState({
      terms: false,
      privacy: true,
    });
  }

  onClickClosePrivacy() {
    this.setState({
      privacy: false,
    });
  }

  render() {
    const { redirectL } = this.state;

    if (redirectL) {
      window.location.href = "/";
    }

    return (
      <div className={this.state.opacity}>
        {!this.props.referencial && (
          <NumericMenu
            ChangeOption={this.ChangeOption}
            menuOptions={[
              { id: 1, label: "Cadastro da Empresa" },
              { id: 2, label: "Cadastro do Usuário" },
            ]}
            block
            ref={this.NumericMenuRef}
          />
        )}
        {this.props.referencial && (
          <div className="signup-right__next-account" id="secondForm">
            <h2 className="signup-right__next-account--title">
              Crie sua conta vinculada à <span>{this.props.otica}</span>
            </h2>
          </div>
        )}
        {this.state.option === 1 && !this.props.referencial && (
          <CadastroEmpresa
            ref={this.CadastroEmpresaRef}
            cnpj={this.props?.cnpj}
            dados={this.state.payload.empresa}
            onUpdateEmpresa={this.handleUpdateEmpresa}
            ChangeOption={this.ChangeOption}
          />
        )}
        {(this.state.option === 2 || this.props.referencial) && (
          <CadastroUsuario
            ref={this.CadastroUsuarioRef}
            cadastrar={this.cadastrar}
            onlyS9={this.props.onlyS9}
            referencial={this.props.referencial}
            ChangeOption={this.ChangeOption}
            onUpdateUsuario={this.handleUpdateUsuario}
            dados={this.state.payload.usuario}
            perfil={this.state.payload.empresa.tipoParticipante}
          />
        )}
        {this.state.terms && <Terms onClick={this.onClickCloseTerms} />}
        {this.state.privacy && <Privacy onClick={this.onClickClosePrivacy} />}
      </div>
    );
  }
}

export default SignupBody;
